import Firstname from 'website/src/js/registration/shared/firstname.js';
import Lastname from 'website/src/js/registration/shared/lastname.js';
import Email from 'website/src/js/registration/shared/email.js';
import Company from './registration-form/company.js';
import Role from 'website/src/js/registration/shared/role.js';
import PhoneNumber from 'website/src/js/registration/shared/phone-number.js';
import Password from './registration-form/password.js';
import Terms from './registration-form/terms.js';
import Captcha from './registration-form/captcha.js';

export default class RegistrationForm {
  constructor(args) {
    this.form = document.querySelector('#form-register-user');
    this.submitButton = document.querySelector('button[type="submit"]');

    this.submitted = false;

    this.company = new Company({
      container: document.querySelector('.cell.company')
    });

    this.firstname = new Firstname({
      container: document.querySelector('.cell.firstname')
    });

    this.phoneNumber = new PhoneNumber({
      container: document.querySelector('.cell.phone-number')
    });

    this.lastname = new Lastname({
      container: document.querySelector('.cell.lastname')
    });

    this.email = new Email({
      container: document.querySelector('.cell.email')
    });
	
    this.role = new Role({
      container: document.querySelector('.cell.role')
    });

    this.password = new Password();
    this.terms = new Terms();
    this.captcha = new Captcha();

    this.addEvents();
  }

  addEvents() {
    this.submitButton.addEventListener('click', e => {
      e.preventDefault();

      const captchaValid   = this.captcha.validate();
      const companyValid   = this.company.validate();
      const firstnameValid = this.firstname.validate();
      const lastnameValid  = this.lastname.validate();
	  const roleValid      = this.role.validate();
      const emailValid     = this.email.validate();
      const phone          = this.phoneNumber.validate();
      const passwordValid  = this.password.validate();
      const termsValid     = this.terms.validate();

      const isValid = captchaValid && companyValid && firstnameValid && lastnameValid && roleValid && emailValid && passwordValid && termsValid;

      if (!isValid || this.submitted) return;

      this.submitted = true;
      this.form.submit();
    });
  }
}